var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapseUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 8,
    viewBox: "0 0 13 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.49371 0.718237C6.62704 0.718237 6.75204 0.739237 6.86871 0.781237C6.98538 0.82257 7.09371 0.893237 7.19371 0.993237L11.8187 5.61824C12.002 5.80157 12.0894 6.0309 12.0807 6.30624C12.0727 6.5809 11.977 6.8099 11.7937 6.99324C11.6104 7.17657 11.377 7.26824 11.0937 7.26824C10.8104 7.26824 10.577 7.17657 10.3937 6.99324L6.49371 3.09324L2.56871 7.01824C2.38538 7.20157 2.15604 7.28924 1.88071 7.28124C1.60604 7.27257 1.37705 7.17657 1.19371 6.99324C1.01038 6.8099 0.918712 6.57657 0.918712 6.29324C0.918712 6.0099 1.01038 5.77657 1.19371 5.59324L5.79371 0.993237C5.89371 0.893237 6.00204 0.82257 6.11871 0.781237C6.23538 0.739237 6.36038 0.718237 6.49371 0.718237Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseUp);
export default __webpack_public_path__ + "static/media/collapse_up.096577ffbbf90cfce52a28f7cca5405d.svg";
export { ForwardRef as ReactComponent };